import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { formatPrice } from '../../utils/helpers';
import toast from 'react-hot-toast';
import './AdminProducts.css';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const navigate = useNavigate();

  const categories = ['', 'T-Shirt', 'Hoodie', 'Sweatshirt', 'Bag', 'Watch', 'Moneybag'];

  const fetchProducts = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (category) params.set('category', category);
    params.set('limit', 100);
    api.get(`/products?${params}`).then(({ data }) => setProducts(data.products)).finally(() => setLoading(false));
  };

  useEffect(() => { fetchProducts(); }, [search, category]);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete "${name}"? This cannot be undone.`)) return;
    try {
      await api.delete(`/products/${id}`);
      setProducts(prev => prev.filter(p => p._id !== id));
      toast.success('Product deleted');
    } catch {
      toast.error('Delete failed');
    }
  };

  return (
    <div>
      <div className="admin-products-header">
        <div>
          <div className="admin-page-title">Products</div>
          <p className="admin-page-sub">{products.length} products total</p>
        </div>
        <Link to="/admin/products/new" className="btn btn-primary">+ Add Product</Link>
      </div>

      {/* Filters */}
      <div className="admin-filters">
        <div className="search-wrap" style={{ position: 'relative', flex: 1, maxWidth: 320 }}>
          <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
          <input
            className="form-input"
            style={{ paddingLeft: 42 }}
            placeholder="Search products..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <select className="filter-select" value={category} onChange={e => setCategory(e.target.value)}>
          {categories.map(c => <option key={c} value={c}>{c || 'All Categories'}</option>)}
        </select>
      </div>

      {/* Table */}
      <div className="admin-table-wrap">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Price</th>
                <th>Sale Price</th>
                <th>Sizes</th>
                <th>Rating</th>
                <th>Featured</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map(product => (
                <tr key={product._id}>
                  <td>
                    <div className="product-cell">
                      <img
                        src={product.thumbnail || 'https://via.placeholder.com/40'}
                        alt={product.name}
                        className="product-thumb"
                      />
                      <span className="product-cell-name">{product.name}</span>
                    </div>
                  </td>
                  <td><span className="badge badge-purple">{product.category}</span></td>
                  <td className="price-cell">{formatPrice(product.price)}</td>
                  <td>{product.salePrice ? <span className="sale-price">{formatPrice(product.salePrice)}</span> : <span className="na">—</span>}</td>
                  <td>
                    <div className="sizes-cell">
                      {product.sizes?.filter(s => s.available).map(s => (
                        <span key={s.label} className="size-mini">{s.label}</span>
                      ))}
                    </div>
                  </td>
                  <td>
                    <span className="stars-mini">{'★'.repeat(Math.round(product.rating || 0))}</span>
                    <span className="rating-mini"> {(product.rating || 0).toFixed(1)}</span>
                  </td>
                  <td>
                    {product.featured
                      ? <span className="badge badge-yellow">⭐ Featured</span>
                      : <span className="na">—</span>
                    }
                  </td>
                  <td>
                    <div className="action-btns">
                      <button className="action-btn view" title="View" onClick={() => window.open(`/products/${product._id}`, '_blank')}>👁</button>
                      <button className="action-btn edit" title="Edit" onClick={() => navigate(`/admin/products/edit/${product._id}`)}>✏️</button>
                      <button className="action-btn delete" title="Delete" onClick={() => handleDelete(product._id, product.name)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {!loading && products.length === 0 && (
          <div className="table-empty">
            No products found.
            <Link to="/admin/products/new" className="btn btn-primary" style={{ marginLeft: 12, fontSize: '0.85rem' }}>Add First Product</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminProducts;
